import React from 'react';

import { useRecuperarMateriaisQuery } from 'View/Service/Default/Materiais';

interface Props {
  unidadeDeAprendizagemId: number;
}

const Materiais = ({ unidadeDeAprendizagemId }: Props): React.ReactElement => {
  const { data: { materiais } = {} } = useRecuperarMateriaisQuery({
    options: { unidade_de_aprendizagem_id: unidadeDeAprendizagemId },
  });

  return (
    <React.Fragment>
      <p className="fs-2 fw-bold">Materiais do professor</p>
      <p>
        Aqui você encontrará os materiais complementares a aula que está
        assistindo. Eles te ajudarão na fixação do conteúdo e ainda são ótimos
        para estudar para sua prova final!
      </p>
      {materiais?.map((material, chave) => (
        <p
          key={`${material.id}-${material.modificado}`}
          className={`fs-4 pt-3 ${chave ? 'border-top' : ''}`}
        >
          <a href={material.url} target="_blank" rel="noreferrer" className="text-decoration-none">
            {material.nome}
          </a>
          <small className="text-muted d-block fs-6">
            Atualizado em {material.modificado.data().toLocaleString()}
          </small>
        </p>
      ))}
    </React.Fragment>
  );
};

export default Materiais;
